//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import Filters from './TableFilters.vue';
import Modal from './Modal.vue';

import tableConfig from './tableConfig';

export default {
  components: { Filters, Modal },

  data() {
    return {
      tableConfig,
      selection: [],
      loader: false,
      editingToken: {
        modal: false,
        data: {},
        isCreating: false,
      },
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('paymentsAndCurrenciesNetworkTokens', ['page', 'pages', 'data', 'sort']),
    ...mapState('paymentsAndCurrenciesNetworks', {
      networks: 'data',
    }),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('paymentsAndCurrenciesNetworkTokens', {
      loadDataAction: 'loadData',
      createCryptoTokenAction: 'createCryptoToken',
      editCryptoTokenAction: 'editCryptoToken',
      deleteCryptoTokenAction: 'deleteCryptoToken',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      // SINGLE TABLE COMPONENT
      // const query = { page: value };
      // this.$router.replace({ query });

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },

    getIconUrl(row) {
      const icon = row.icons?.[0];
      if (icon) return icon.includes('://') ? icon : `${constant.settings.EXCHANGE_URL}${icon}`;
      return null;
    },

    editCurrency(row) {
      this.editingToken.modal = true;
      this.editingToken.data = { ...row };
      this.editingToken.isCreating = false;
    },

    createCurrency() {
      this.editingToken.modal = true;
      this.editingToken.data = {};
      this.editingToken.isCreating = true;
    },

    applyEdit({ input }) {
      const { isCreating } = this.editingToken;
      this.confirmAction({
        title: isCreating
          ? 'Are you sure you want to create token?'
          : 'Are you sure you want to edit token?',
        callback: async () => {
          this.setGeneralProgress(true);
          this.loader = true;
          try {
            if (isCreating) {
              await this.createCryptoTokenAction(input);
            } else {
              await this.editCryptoTokenAction(input);
            }
            this.editingToken.modal = false;
            await this.loadDataAction({});
            if (isCreating) {
              this.setSuccessNotification('Token created');
            } else {
              this.setSuccessNotification('Token edited');
            }
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
          this.loader = false;
        },
      });
    },

    deleteCurrency(row) {
      this.confirmAction({
        title: 'Are you sure you want to delete token?',
        callback: async () => {
          this.setGeneralProgress(true);
          this.loader = true;
          try {
            await this.deleteCryptoTokenAction(row.id);
            await this.loadDataAction({});
            this.setSuccessNotification('Token deleted');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralProgress(false);
          this.loader = false;
        },
      });
    },

    getNetworkTitle(row) {
      const network = this.networks?.find((e) => e.id === row.cryptoCurrencyId);
      if (!network) return '';

      return network.title;
    },


    async copy(value) {
      await navigator.clipboard.writeText(value);
      this.setSuccessNotification('Copied to clipboard');
    },
  },
};
